import React from 'react';
import './PartnerFeatures.css';

const PartnerFeatures = () => {
  const features = [
    {
      icon: '₹',
      title: 'Earn 40K-80K Monthly',
      description: 'Our top partners consistently earn between ₹40,000 to ₹80,000 every month'
    },
    {
      icon: '👥',
      title: '1,000+ Active Partners',
      description: 'Join a growing community of successful creators already on our platform'
    },
    {
      icon: '⚡',
      title: 'Fast-Growing Platform',
      description: 'Take advantage of our rapidly expanding user base across India'
    }
  ];

  return (
    <section className="partner-features">
      <div className="container">
        <div className="partner-features-grid">
          {features.map((feature, index) => (
            <div key={index} className="partner-feature-card">
              <div className="partner-feature-icon">
                <span>{feature.icon}</span>
              </div>
              <h3 className="partner-feature-title">{feature.title}</h3>
              <p className="partner-feature-description">{feature.description}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default PartnerFeatures;

